function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8992",
    transform: "translate(-1166 -710)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3537",
    width: 40,
    height: 24,
    rx: 12,
    transform: "translate(1166 710)",
    style: {
      fill: "#9da7b2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3538",
    width: 20,
    height: 20,
    rx: 10,
    transform: "translate(1168 712)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveToggle);
export default __webpack_public_path__ + "static/media/InactiveToggle.1e21dbdb1566d96ec7c659b66ca37257.svg";
export { ForwardRef as ReactComponent };